export default __webpack_public_path__ + "static/media/Shield of the Bull.6373668c.PNG";